import { render, staticRenderFns } from "./BbppDigitalPlatformsASO.vue?vue&type=template&id=75878dee"
import script from "./BbppDigitalPlatformsASO.vue?vue&type=script&lang=js"
export * from "./BbppDigitalPlatformsASO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports